import { PREP_SCRIBE_FOR_EDITOR_SUCCESS } from 'JS/actionCreators/scribeActions';
import { call, take } from 'redux-saga/effects';

import { track } from '../mixpanelProvider';

export default function* trackTemplateLoadedSaga(baseEventProperties) {
  const { assets } = yield take('TEMPLATE_ASSETS_FETCHED_FROM_CONTENTFUL');

  const sizeOfAssets = assets.reduce((counter, asset) => {
    return counter + asset.fields?.file?.details?.size || 0;
  }, 0);
  const numberOfImages = assets.filter(asset => asset.fields?.file?.contentType?.includes('image')).length;
  const numberOfAudio = assets.filter(asset => asset.fields?.file?.contentType?.includes('audio')).length;

  const { scribe } = yield take(PREP_SCRIBE_FOR_EDITOR_SUCCESS);

  yield call(track, 'Template Loaded', {
    ...baseEventProperties,
    'Scribe ID': scribe.id,
    'Size of Assets': sizeOfAssets,
    'Number of Images': numberOfImages,
    'Audio Exists': numberOfAudio > 0
  });
}
